var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 207.631,
    x2: 264.389,
    y1: 317.07,
    y2: 317.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc8241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dea861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 140.969,
    x2: 353.528,
    y1: 64.586,
    y2: 187.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dea861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebcba0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab2c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7a85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 321.931,
    x2: 358.222,
    y1: 94.175,
    y2: 31.318,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: 276.983,
    x2: 255.889,
    y1: 134.368,
    y2: 97.832,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 248.854,
    x2: 120.941,
    y1: 149.795,
    y2: 181.569,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M462.593 379.572V122.14L49.407 139.858V397.29c-.001 5.899 2.918 11.798 8.756 15.168l163.68 94.501a37.623 37.623 0 0 0 37.624 0L453.836 394.74c5.839-3.37 8.758-9.269 8.757-15.168z",
    opacity: 1,
    "data-original": "url(#b)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M58.163 124.692 252.532 12.473a37.623 37.623 0 0 1 37.624 0l163.68 94.501c11.675 6.741 11.675 23.593 0 30.333L259.468 249.525a37.623 37.623 0 0 1-37.624 0l-163.68-94.5c-11.676-6.741-11.676-23.593-.001-30.333z",
    opacity: 1,
    "data-original": "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4757",
    d: "m121.187 88.305 208.761 120.529 55.377-31.972L176.563 56.333z",
    opacity: 1,
    "data-original": "#ff4757"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab2c37",
    d: "M329.948 208.834v257.084l55.377-31.972V176.862z",
    opacity: 1,
    "data-original": "#ab2c37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4757",
    d: "M407.133 79.943 167.489 218.428l-55.377-31.971L351.756 47.971z",
    opacity: 1,
    "data-original": "#ff4757"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab2c37",
    d: "M167.489 218.428v257.085l-55.377-31.972V186.457z",
    opacity: 1,
    "data-original": "#ab2c37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M277.278 106.286a14.031 14.031 0 0 1-2.401-13.25c7.524-22.692 28.836-80.795 64.345-91.558 33.181-10.057 74.945 33.042 48.482 73.967-21.072 32.587-71.034 42.192-90.518 44.754a14.044 14.044 0 0 1-12.772-5.084z",
    opacity: 1,
    "data-original": "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab2c37",
    d: "M364.171 48.216c15.637-8.556 23.878 1.198 18.538 16.981s-32.666 30.827-48.894 38.766-38.509 10.805-38.509 10.805 53.228-57.995 68.865-66.552z",
    opacity: 1,
    "data-original": "#ab2c37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M297.809 71.213c-9.311-1.18-17.267.343-23.649 3.622v.001a33.341 33.341 0 0 0-2.854 1.648l-41.403 23.918.013.023c-7.292 3.669-13.799 10.303-18.039 20.399-4.303 33.603 26.779 49.905 49.03 37.058l44.479-25.68c22.25-12.846 23.674-47.913-7.577-60.989z",
    opacity: 1,
    "data-original": "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M236.498 123.344a14.031 14.031 0 0 0-11.748-6.581c-23.905-.269-85.781.979-107.512 31.056-20.306 28.104 6.861 81.618 54.169 69.91 37.67-9.323 63.008-53.442 71.769-71.032a14.044 14.044 0 0 0-.652-13.731z",
    opacity: 1,
    "data-original": "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab2c37",
    d: "M153.317 186.616c-13.178 12.002-6.636 22.969 10.026 23.054s39.778-20.859 52.565-33.621 22.746-32.898 22.746-32.898-72.158 31.463-85.337 43.465z",
    opacity: 1,
    "data-original": "#ab2c37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.750e8579be6709a1e36f51b456e2d1fe.svg";
export { ForwardRef as ReactComponent };